module.exports = __webpack_public_path__ + "img/4-3-1-5-2-preview-gz-seminar-e.60eb1f17.jpg";